import React, { useState } from "react";
import "./ComplianceOnboarding.css";

const ComplianceOnboarding = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [consentChecked, setConsentChecked] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!phoneNumber.trim()) {
      alert("Please enter a phone number");
      return;
    }
    if (!consentChecked) {
      alert("Please provide consent to proceed");
      return;
    }
    setSubmitted(true);
    // Handle form submission here
    console.log("Form submitted:", { phoneNumber, consentChecked });
  };

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center p-5">
        <div className="compliance-card success">
          <h2>Thank You!</h2>
          <p>Your information has been received. We'll be in touch soon.</p>
          <button onClick={() => setSubmitted(false)} className="btn-primary">
            Submit Another
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-5">
      <div className="compliance-card">
        <div className="compliance-header">
          <h1>Join Our Testing Team</h1>
          <p className="subtitle">
            Get started by providing your contact information
          </p>
        </div>

        <form onSubmit={handleSubmit} className="compliance-form">
          {/* Phone Number Input Field */}
          <div className="form-group">
            <label htmlFor="phoneNumber" className="form-label">
              Phone Number <span className="required">*</span>
            </label>
            <input
              type="tel"
              id="phoneNumber"
              placeholder="+1 (555) 123-4567"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className="form-input"
              required
            />
            <small className="form-help">
              Enter your mobile number to participate in RCS messaging tests.
            </small>
          </div>

          {/* Consent Checkbox */}
          <div className="form-group checkbox-group">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                id="consentCheckbox"
                checked={consentChecked}
                onChange={(e) => setConsentChecked(e.target.checked)}
                className="form-checkbox"
              />
              <label htmlFor="consentCheckbox" className="checkbox-label">
                I opt-in to receive SMS/RCS messages for internal testing
                purposes and agree to the privacy policy and terms below.
              </label>
            </div>
          </div>

          {/* Compliance Disclosures */}
          <div className="compliance-disclosures">
            <h3>Important Information</h3>

            <div className="disclosure-section">
              <h4>Terms & Policies</h4>
              <p>
                By opting in, you agree to our{" "}
                <a
                  href="/api/terms-of-service"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="disclosure-link"
                >
                  Terms of Service
                </a>{" "}
                and{" "}
                <a
                  href="/api/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="disclosure-link"
                >
                  Privacy Policy
                </a>
                .
              </p>
            </div>

            <div className="disclosure-section">
              <h4>Message Information</h4>
              <ul className="disclosure-list">
                <li>
                  <strong>Message & Data Rates May Apply:</strong> Standard
                  message and data rates from your wireless carrier may apply to
                  all messages sent to and received from this service.
                </li>
                <li>
                  <strong>Messaging Frequency:</strong> You will receive
                  periodic messages. Frequency may vary based on your
                  preferences and activity.
                </li>
              </ul>
            </div>

            <div className="disclosure-section">
              <h4>Support & Opt-Out</h4>
              <ul className="disclosure-list">
                <li>
                  <strong>HELP:</strong> Text "HELP" to our support number for
                  additional information about this service.
                </li>
                <li>
                  <strong>STOP:</strong> Text "STOP" at any time to opt-out of
                  receiving future messages. You will receive a confirmation
                  message.
                </li>
              </ul>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="btn-submit"
            disabled={!phoneNumber.trim() || !consentChecked}
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  );
};

export default ComplianceOnboarding;
